'use strict';
define([
    'angular',
    'modules/settings/api/api.controller'
],function(angular,ApiController){
    var app=angular.module('settings.api', []);
    app.controller('ApiController',ApiController);
    return app;
});
